module.exports = __webpack_public_path__ + "img/03_06特別審査員賞2.f2144bdb.png";